import {h, Component} from 'preact'
import {DropdownSelectizeGroup} from '../dropdown/DropdownSelectize'

export interface Category {
  categoryId: number,
  categoryName: string
}

export interface Group {
  groupId: number,
  groupName: string,
  type: 4 | 5,
}

export interface ParentCategory {
  groupId: number,
  groupName: string,
  type: 0 | 1 | 2 | 3,
  categories?: Array<Category>
}

export interface ParentCategoryWithCategories extends Exclude<ParentCategory, 'categories'>{
  categories: Array<Category>
}

interface Props {
  categories: Array<ParentCategory | Group>,
  selectedCategoryId?: number,
  onUpdate: (value: number) => void,
  placeholder?: string
}

export function hasCategories(c: ParentCategory | Group): c is ParentCategoryWithCategories {
  return 'categories' in c && !!c.categories && !!c.categories.length
}

export function isGroup (c: ParentCategory | Group): c is Group {
  return c.type === 4 || c.type === 5
}

export function normalizeForDropdown(categories: Props['categories']): Array<ParentCategoryWithCategories> {
  const groupCategory: ParentCategoryWithCategories = {
    groupId: 0,
    groupName: 'Groups',
    type: 1,
    categories: []
  }

  return categories.reduce((acc: Array<ParentCategory>, parentOrGroup: ParentCategory | Group) => {
    if (isGroup(parentOrGroup)) {
      groupCategory.categories.push({
        categoryId: parentOrGroup.groupId,
        categoryName: parentOrGroup.groupName,
      })
      return acc
    }
    return acc.concat([parentOrGroup])
  }, [])
  .concat([groupCategory])
  .filter(hasCategories)
}

export default class CategorySelector extends Component<Props> {
  render (props: Props) {
    const {categories, selectedCategoryId, placeholder} = props

    return <DropdownSelectizeGroup
      class='qa-category-select'
      placeholder={placeholder || 'Select category ...'}
      selectedValue={selectedCategoryId}
      onUpdate={this.props.onUpdate}
      optgroup={normalizeForDropdown(categories)
        .map(parentCategory => {
          return {
            label: parentCategory.groupName,
            items: parentCategory.categories.map(item => {
              return {
                value: item.categoryId,
                label: item.categoryName
              }
            })
          }
        })} />
  }
}
